import React from 'react'
import DealInfoContainer from 'containers/Deal/DealInfo'

const DealInfoPage = () => <DealInfoContainer />

export default DealInfoPage
